import React from 'react';

import Table from '../../../../../Table';

const cols = [
  {
    title: 'Policy Number',
    keys: ['policy_number'],
    link: (row) => `/loans/${row.loan_id}/insurances/${row.id}?tab=Insurance`,
  },
  {
    title: 'Insurance Payee',
    keys: ['send_payment_to'],
  },
  {
    title: 'Payee',
    keys: ['send_payment_to'],
    format(value, row) {
      switch (value) {
        case 'Carrier':
          return row?._carrier?.name;
        case 'Agent':
          return row?._agent?.name;
        case 'Broker':
          return row?._broker?.name;
        default:
          return value;
      }
    },
    link: (row) => {
      if (
        row.send_payment_to === 'Carrier' ||
        row.send_payment_to === 'Agent'
      ) {
        return `/vendors/${row.vendor_id}?tab=Vendor`;
      }
      return null;
    },
  },
  {
    title: 'Start Date',
    keys: ['start_date'],
    type: 'date',
  },
];

export default function BillInsurancesTable({ bill }) {
  const rows = bill?._insurances?.length
    ? bill?._insurances
    : bill?._insurances_via_next_bill || [];

  return (
    <div>
      <Table
        cols={cols}
        rows={rows}
        title={
          bill?._insurances?.length
            ? 'Insurance Policies'
            : 'Insurance policy this bill is scheduled to pay'
        }
        noCount
      />
    </div>
  );
}
